module.exports = __webpack_public_path__ + "static/20250407_Press_Release_Consent_Solicitation-3a4f2c5fcaf95eac417218d9745d8b9e.pdf";